<template lang="pug">
div
  .search-controls
    .control.is-large.is-expanded
      input.input.is-large#local-coin-search(
        type="text" 
        placeholder='Search for your coin / token', 
        v-model='filter'
        @click="focusFirst"
        @keyup="focusFirst"
        @keydown.enter="clickFirst"
        tabindex="1"
        ref='inputcoin'
        spellcheck='false'
      )
    div.filter-type.is-flex.has-text-centered
      .flex-1
        span.title-tag 
          span Filter 
          span.filter-extra-text by tags
          span : 
        .tag(
          v-for="o in coinTags"
          :class="{'selected': o.selected, 'new': o.code == 'new'}"
          @click="toggleTag(o)"
        ) {{ o.name }}
    //- div.filter-type.is-flex.mb-5.text-white-on-dark(v-if="coinCategories && coinCategories.types")
      span.title-tag 
        span Filter 
        span.filter-extra-text by token type 
        span : 
      .flex-1
        .tag.text-white-on-dark(
          v-for="o in coinCategories.types"
          :class="{'selected': o === typeSelected}"
          @click="typeSelected === o ? typeSelected = '' : typeSelected = o"
        ) {{ o }}
    div.mt-20.mb-20.has-text-centered(v-if="isLoading") Loading coins...
  .categories(v-if="!isLoading", :style="maxHeightContainer > 0 ? 'max-height: ' + maxHeightContainer + 'px' : ''")
    .box-shadow-container.top.box-shadow-container-top(v-show="showTopShadow")
    .categories-container(:id="id", :style="maxHeightContainer > 0 ? 'max-height: ' + maxHeightContainer + 'px' : ''")
      template(v-for="(c, index) in filteredList.coins", v-if="c.list.length > 0")
        .category-title.text-white-on-dark(@click="toggleSection(index)")
          div.flex-1
            span {{ c.category }} 
            span.count ({{ c.list.length }})
          div.caret
            i.fa(:class="{'fa-caret-up': toggleCategories[index], 'fa-caret-down': !toggleCategories[index]}")
        .columns.is-multiline.is-mobile(v-if="toggleCategories[index]")
          .column.coin-selector-column.is-one-third-tablet.is-one-fifth-desktop.is-one-third-widescreen.is-one-fifth-fullhd.is-half-mobile(
            v-for="(o, idx) in c.list"
          )
            .info-miner.w100.bottom-10.coin-selector(href="#", @click="selectCoin(o)", tabindex="2", @keydown.enter="selectCoin(o)", @keydown.tab="removeOtherFocus()", @mouseover="removeOtherFocus()", :class="{ 'is-loading': isLoadingCoin[o.symbol] }")
              .img-container
                .img-box
                  img(:src="o.logo", :alt="o.symbol + ' icon'")
                  .new-tag(v-if="o.top === 1") New
                  .new-tag.delisted(v-else-if="o.delisted === 1") Delisted
                  .coin-loading(v-if="isLoadingCoin[o.symbol]")
                    i.fa.fa-circle-o-notch.fa-spin
              p
                b {{ o.name }}
              p
                span {{ o.symbol }}
    .box-shadow-container.bottom.box-shadow-container-bottom(v-show="showBottomShadow")
</template>

<script>
import { nanoid } from 'nanoid'
export default {
  name: 'c_coin_list',
  data() {
    return {
      maxHeightContainer: 0,
      showTopShadow: false,
      showBottomShadow: false,
      isLoading: true,
      filter: '',
      coinTags: [
        {
          name: 'New',
          code: 'new',
          selected: false
        },
        {
          name: 'Meme',
          code: 'meme',
          selected: false
        },
        {
          name: 'ERC20',
          code: 'erc20',
          selected: false
        },
        {
          name: 'BEP20',
          code: 'bep20',
          selected: false
        },
        {
          name: 'TRC20',
          code: 'trc20',
          selected: false
        },
        {
          name: 'Solana',
          code: 'solana',
          selected: false
        }
      ],
      typeSelected: '',
      coinCategoriesLocal: [],
      toggleCategories: [],
      toggleCategoriesHelper: [],
      isDown: false,
      startY: 0,
      scrollTop: 0,
      lastTimeDown: 0,
      isLoadingCoin: {}
    }
  },
  created() {
    let vm = this
    vm.fetch()
  },
  mounted() {
    let vm = this
    if (window && window.innerWidth > 500) {
      vm.$refs.inputcoin.focus()
    }
    vm.$root.$on('clearListeners', () => {
      let container = document.getElementById(vm.id)
      if (container) {
        container.removeEventListener('scroll', vm.reprintShadowScroll)
      }
      window.removeEventListener('resize', vm.reprintShadowScroll);
      window.removeEventListener('resize', vm.resizeInnerContainer);
    })
  },
  unmounted() {
    let vm = this
    let container = document.getElementById(vm.id)
    container.removeEventListener('scroll', vm.reprintShadowScroll)
    window.removeEventListener('resize', vm.reprintShadowScroll);
    window.removeEventListener('resize', vm.resizeInnerContainer);
  },
  computed: {
    id() {
      return 'coin-container-' + nanoid(10)
    },
    lastCoinsSelected () {
      return this.$store.getters.lastCoins
    },
    coins() {
      return this.$store.getters.coins
    },
    coinCategories() {
      return this.$store.getters.coinCategories
    },
    filteredList() {
      let vm = this
      // if (vm.filter || vm.typeSelected) {
      if (vm.filter || vm.typeSelected) {
        let newCoinCategories = []
        for (let i = 0; i < vm.coinCategoriesLocal.coins.length; i++) {
          const element = vm.coinCategoriesLocal.coins[i];
          let newElement = {}
          let coinsFiltered = element.list.filter(o =>
            o.name.toUpperCase().includes(vm.filter.toUpperCase()) || o.symbol.toUpperCase().includes(vm.filter.toUpperCase())
          )
          if (!vm.filter) {
            if (vm.typeSelected) {
              let coinsTypeFiltered = []
              for (let j = 0; j < coinsFiltered.length; j++) {
                let addItem = false
                if (coinsFiltered[j].tags) {
                  let tagsToCheck = coinsFiltered[j].tags.split(',')
                  for (let item of tagsToCheck) {
                    if (vm.typeSelected.split(',').indexOf(item) > -1) {
                      addItem = true
                      break
                    }
                  }
                }
                // for (let k = 0; k < coinsFiltered[j].chains.length; k++) {
                //   if (coinsFiltered[j].chains[k].token_standard === vm.typeSelected) addItem = true
                // }
                if (addItem) coinsTypeFiltered.push(coinsFiltered[j])
              }
              coinsFiltered = coinsTypeFiltered
            }
          }
          newElement.category = element.category
          newElement.list = coinsFiltered
          newCoinCategories.push(newElement)
        }

        if (vm.toggleCategoriesHelper.length === 0) {
          vm.toggleCategoriesHelper = []
          for (let i = 0; i < vm.toggleCategories.length; i++) {
            vm.toggleCategoriesHelper.push(vm.toggleCategories[i]);
            vm.toggleCategories[i] = true
          }
        }

        return {
          // types: vm.coinCategoriesLocal.types,
          coins: newCoinCategories
        }
      } else {
        vm.toggleCategories = vm.toggleCategoriesHelper.length > 0 ? vm.toggleCategoriesHelper : vm.toggleCategories
        vm.toggleCategoriesHelper = []
        return vm.coinCategoriesLocal
      }
    }
  },
  methods: {
    removeOtherFocus() {
      document.querySelectorAll('.pre-selected').forEach(item => item.classList.remove('pre-selected'));
    },
    clickFirst() {
      if (document.querySelectorAll('.coin-selector')[0]) document.querySelectorAll('.coin-selector')[0].click();
    },
    focusFirst() {
      let vm = this
      vm.removeOtherFocus()
      if (document.querySelectorAll('.coin-selector')[0]) document.querySelectorAll('.coin-selector')[0].classList.add('pre-selected');
    },
    resizeInnerContainer() {
      let vm = this
      let actualSize = document.querySelector('.modal-card-body').clientHeight - document.querySelector('.search-controls').clientHeight
      vm.maxHeightContainer = actualSize;
    },
    reprintShadowScroll(e) {
      let vm = this
      let container = document.getElementById(vm.id)

      if (!container || container.clientHeight === 0) {
        setTimeout(function () {
          vm.reprintShadowScroll()
        }, 100)
      } else {
        if (container.scrollHeight - container.clientHeight === 0) {
          // There is no scroll
          vm.showTopShadow = false
          vm.showBottomShadow = false
        } else {
          if (container.scrollTop !== 0) vm.showTopShadow = true
          else vm.showTopShadow = false

          if ((container.scrollHeight - container.clientHeight) - container.scrollTop < 1.1) {
            vm.showBottomShadow = false
          } else {
            vm.showBottomShadow = true
          }
        }
      }
    },
    async fetch() {
      let vm = this

      await vm.$store.dispatch('getCoins')

      vm.coinCategoriesLocal = {}
      // vm.coinCategoriesLocal.types = vm.coinCategories.types
      vm.coinCategoriesLocal.coins = []

      let aux = {
        category: 'Recently viewed',
        list: []
      }

      for (var i = 0; i < vm.lastCoinsSelected.length; i++) {
        for (var j = 0; j < vm.coins.length; j++) {
          if (vm.lastCoinsSelected[i] === vm.coins[j].symbol) {
            aux.list.push(vm.coins[j])
          }
        }
      }

      vm.coinCategoriesLocal.coins.push(aux)
      vm.coinCategoriesLocal.coins.push({
        category: 'All coins & tokens',
        list: [...vm.coins]
      })

      vm.toggleCategories.push(true)
      vm.toggleCategories.push(true)

      // for (let i = 0; i < vm.coinCategories.coins.length; i++) {
      //   const element = vm.coinCategories.coins[i];
      //   vm.coinCategoriesLocal.coins.push(element)
      //   vm.toggleCategories.push(true)
      // }

      vm.$nextTick(() => {
        vm.isLoading = false
        setTimeout(function () {
          vm.reprintShadowScroll()
          vm.resizeInnerContainer()
          vm.focusFirst();

          let container = document.getElementById(vm.id)
          container.addEventListener('scroll', vm.reprintShadowScroll)
          window.addEventListener('resize', vm.reprintShadowScroll);
          window.addEventListener('resize', vm.resizeInnerContainer);

          container.addEventListener('mousedown', (e) => {
            vm.lastTimeDown = +new Date();
            vm.isDown = true;
            vm.startY = e.pageY - container.offsetTop;
            vm.scrollTop = container.scrollTop;
          });
          container.addEventListener('mouseleave', () => {
            vm.isDown = false;
          });
          container.addEventListener('mouseup', () => {
            let itemsInContainer = container.querySelectorAll('div');
            for (let itemInContainer of [...itemsInContainer]) {
              itemInContainer.style.pointerEvents = null;
            }
            vm.isDown = false;
          });
          container.addEventListener('mousemove', (e) => {
            if (vm.lastTimeDown && vm.lastTimeDown > +new Date() - 100) return
            if (!vm.isDown) return;
            e.preventDefault();
            let itemsInContainer = container.querySelectorAll('div');
            for (let itemInContainer of [...itemsInContainer]) {
              itemInContainer.style.pointerEvents = 'none';
            }
            const x = e.pageY - container.offsetTop;
            const walk = (x - vm.startY) * 1; // scroll-normal
            container.scrollTop = vm.scrollTop - walk;
          });
        }, 100)
      })
    },
    selectCoin(o) {
      let vm = this
      vm.isLoadingCoin = {}
      vm.$set(vm.isLoadingCoin, o.symbol, true)
      vm.$emit('selected', o)
    },
    toggleSection(index) {
      let vm = this
      vm.$set(this.toggleCategories, index, !vm.toggleCategories[index])
    },
    toggleTag (o) {
      let vm = this
      let currentTypes = vm.typeSelected;
      currentTypes = currentTypes === '' ? [] : currentTypes.split(',')
      if (currentTypes.indexOf(o.code) > -1) {
        currentTypes.splice(currentTypes.indexOf(o.code), 1)
        o.selected = false
      } else {
        currentTypes.push(o.code)
        o.selected = true
      }
      vm.typeSelected = currentTypes.join(',')
    }
  }
}
</script>

<style lang="stylus" scoped>

.coin-selector.is-loading
  // pointer-events none
  .img-container .img-box img
    opacity .5

.img-container
  display block
  .img-box
    display inline-block
    position relative
    img
      border-radius 5px
    .coin-loading
      position: absolute;
      top: 6px;
      left: 0;
      width 100%
      font-size 20px
.new-tag
  position: absolute;
  background: #b6ffb6;
  color: #000;
  bottom: 10px;
  right: -12.5px;
  font-size: 8px;
  padding: 2px 5px;
  font-weight: 700;
  border-radius: 5px;
  &.delisted
    background: #fff5b6;
.search-controls
  padding 20px 20px 0px 20px
.filter-type
  text-align center
  padding 15px 0px 10px 0px
  .title-tag
    font-size 0.8rem
    padding-top 4px
  .tag
    font-size 0.8rem
    cursor pointer
    margin-left 5px
    margin-bottom 5px
    color: #717171
    background-color transparent
    border-color: #e5e5e5;
    border-style: solid;
    border-width: 1px;
    user-select: none;
    &.selected
      border-color: #717171;
      font-weight 400
    &.new.selected
      border-color: #609660;
    &.new
      border-color: #b0e7b0;
      color: #519251;
.category-title
  margin-bottom: 15px;
  padding-bottom: 5px;
  border-bottom: solid 1px #dbdbdb;
  text-align: left
  padding-left: 20px
  font-weight 800
  display flex
  cursor pointer
.caret
  padding-right 10px
  padding-left 10px

.count
  font-size: 11px;
  color: #ccc;

.categories
  max-height 600px
  overflow: hidden
  position relative
  .categories-container
    padding 10px 20px 10px 20px
    max-height: 600px;
    scrollbar-width: none;
    // padding: 15px 0px;
    overflow-y: auto;
    overflow-x: hidden;

.box-shadow-container
  width 100%
  height 20px
  position absolute
  z-index: 10;
  display flex
  align-items center
  padding 5px
  cursor pointer
  -webkit-tap-highlight-color: transparent;
  &.top
    top 0px
    left 0px
    box-shadow: inset 0px 10px 14px -13px #000;
  &.bottom
    bottom 0px
    left 0px
    box-shadow: inset 0px -10px 14px -13px #000;

html.dark, body.dark
  .filter-type .tag.new
    border-color: #fff;
  .filter-type .tag.selected.new
    background-color: #b6ffb6;
    border-color: #b6ffb6;
  .filter-type
    .title-tag
      color #fff
    .tag
      color #fff
      &.selected
        color #000
        background-color #fff
        border-color #fff
  .new-tag
    color #000
</style>



// WEBPACK FOOTER //
// c_coin_list.vue?47470c60